import React from 'react'

import DefaultSignup from './Default'
import { enhance } from './enhance'
import SpendSignup from './Spend'

type Props = {
  flow: string
}

export const Signup: React.SFC<Props> = ({ flow }) => {
  return flow.toLowerCase() === 'spend' ? <SpendSignup /> : <DefaultSignup />
}

export default enhance(Signup)
